import { render } from "./Table.vue?vue&type=template&id=66ea27f6&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts&setup=true"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/SymptomRecords/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66ea27f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66ea27f6', __exports__)) {
    console.log('reload')
    api.reload('66ea27f6', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=66ea27f6&ts=true", () => {
    console.log('re-render')
    api.rerender('66ea27f6', render)
  })

}


export default __exports__